import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 21.19 29.95",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { fill: "#fff" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m18.35 29.92-15.26.04c-1.55 0-3.06-1.11-3.06-2.76L0 14.27c0-1.93 1.63-3.24 3.53-2.99l.03-4.65c.22-4.3 4.25-7.34 8.47-6.49 3.18.65 5.56 3.43 5.58 6.69l.03 4.44c1.86-.27 3.53 1.01 3.54 2.9l.02 12.55c0 1.61-1.02 3.19-2.84 3.19zm-2.34-18.67V7.14c.02-3.04-2.32-5.5-5.33-5.56s-5.5 2.25-5.52 5.23l-.02 4.44zm3.82 15.68V14.16c-.01-.92-.79-1.54-1.65-1.54H2.99c-.94 0-1.64.72-1.64 1.64v12.83c.01.86.86 1.47 1.65 1.47h15.36c.83-.12 1.48-.7 1.48-1.63z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M11.59 24.35H9.66c-.11 0-.34-.05-.43-.13-.1-.09-.16-.43-.13-.56l.45-2.46c-.81-.47-1.2-1.31-1.05-2.21.14-.82.82-1.54 1.73-1.69 1.05-.17 2.01.4 2.35 1.35s.01 2.02-.94 2.54l.46 2.58c.04.25-.22.59-.5.59z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }